import React from 'react';
import PropTypes from 'prop-types';
import { PASSWORD_REQUIREMENTS } from '../../constants/password';

/**
 * Password requirements checklist component
 * Shows real-time validation status as user types
 */
const PasswordRequirements = ({ password = '', showChecklist = true }) => {
    if (!showChecklist) {
        return null;
    }

    return (
        <div className="password-requirements">
            <small className="password-requirements-title">Password must contain:</small>
            <ul className="password-requirements-list">
                {PASSWORD_REQUIREMENTS.map(({ key, label, test }) => {
                    const isValid = password && test(password);
                    return (
                        <li
                            key={key}
                            className={`password-requirement ${isValid ? 'valid' : ''}`}
                        >
                            <span className="requirement-icon"></span>
                            <span className="requirement-text">{label}</span>
                        </li>
                    );
                })}
            </ul>
            <style>{`
                .password-requirements {
                    width: 100%;
                    margin-block: 10px;
                    padding: 12px 14px;
                    background: #f8f9fa;
                    border-radius: 6px;
                    border: 1px solid #e9ecef;
                }
                .password-requirements-title {
                    display: block;
                    font-size: 12px;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 8px;
                }
                .password-requirements-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    display: grid;
                    gap: 4px;
                }
                .password-requirement {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 12px;
                    color: #6c757d;
                    transition: color 0.2s ease;
                }
                .password-requirement.valid {
                    color: #20a8d8;
                }
                .requirement-icon {
                    width: 16px;
                    height: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 11px;
                    border-radius: 50%;
                    flex-shrink: 0;
                    position: relative;
                }
                .password-requirement:not(.valid) .requirement-icon {
                    border: 1px solid #adb5bd;
                    color: #adb5bd;
                    font-size: 8px;
                }
                .password-requirement.valid .requirement-icon {
                    background: #20a8d8;
                    color: white;
                    font-weight: bold;
                }
                .password-requirement.valid .requirement-icon::after {
                    content: '✓';
                    position: absolute;
                    top: 58%;
                    left: 54%;
                    transform: translate(-50%, -50%);
                }
                .requirement-text {
                    line-height: 1;
                    margin-top: 2px;
                }
            `}</style>
        </div>
    );
};

PasswordRequirements.propTypes = {
    password: PropTypes.string,
    showChecklist: PropTypes.bool,
};

export default PasswordRequirements;
